"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseEntity = void 0;
var BaseEntity = /** @class */ (function () {
    function BaseEntity(data) {
        this.id = data.id;
        this.seo = {
            title: data.seo_title,
            description: data.seo_description,
            keywords: data.seo_keywords,
            canonical: data.seo_canonical
        };
    }
    return BaseEntity;
}());
exports.BaseEntity = BaseEntity;
//# sourceMappingURL=BaseEntity.js.map